<!--
 * @Description: 车型识别一体机-左
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-24 15:57:14
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-25 09:54:12
 -->
<template>
  <div class="leftModule">
    <div class="topPart">
      <div class="title">车型监测识别一体机</div>
      <div class="describe">专业治超不松懈，守住安全的底线</div>
    </div>
    <div class="middlePart">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">应用场景</span>
      </div>
      <div class="content">
        用于出入口治超车道的车型检测与识别，满足交通部<span>《高速公路称重检测业务规范和技术要求》</span>，具备<span>高清图像抓拍、视频取证、车型及车牌识别</span>等功能。为高速公路违法超限超载治理提供清晰完整的图像监测数据。
      </div>
    </div>
    <div class="bottomPart">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">主要功能</span>
      </div>
      <div class="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'leftModule',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .leftModule {
    width: 82%;
    height: 100%;
    margin-left: 18%;
    .topPart {
      height: 24%;
      .title {
        font-size: 3vh;
        color: rgb(236, 235, 80);
        font-weight: bold;
        text-align: center;
        margin-bottom: 5%;
        padding-top: 7vh;
      }
      .describe {
        font-size: 2.8vh;
        color: rgb(16, 186, 186);
        text-align: center;
      }
    }
    .middlePart {
      height: 25%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        margin-bottom: 2.5vh;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        font-size: 1.5vh;
        color: #05dbe3;
        line-height: 3.4vh;
        >span:nth-of-type(1) {
          font-weight: bold;
        }
        >span:nth-of-type(2) {
          font-weight: bold;
          color: rgb(236, 235, 80);
        }
      }
    }
    .bottomPart {
      height: 35%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        margin-bottom: 2.8vh;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        width: 96%;
        height: 27vh;
        border-radius: 6px;
        background: url('/static/img/layout/truck.png');
        background-size: 100% 100%;
      }
    }
  }
</style>
